import axios from 'axios';

export default class DestinationService {

	constructor(client){
		this.url = '/clients-webservice/destinations';
		this.auth = {
				username: client.login,
				password: client.key
		}
	};

	getHotelsAndCitiesByName(name) {
		return axios.get(`${this.url}?name=${name}`, {auth: this.auth});
	}
}



// WEBPACK FOOTER //
// ./src/services/DestinationService.js